import { apiClient } from "@base/api/client";
import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { type ProjectTradeItem, type TradeType, projectTradeItemSchema } from "./projectTradesSchema";

interface CreateProjectTradeRequest {
  projectId: string;
  name: string;
  type: TradeType;
}

async function createProjectTrade({ projectId, name, type }: CreateProjectTradeRequest): Promise<ProjectTradeItem> {
  const response = await apiClient.post<unknown>(`/project-management/api/projects/${projectId}/trades`, {
    name,
    type,
  });
  return projectTradeItemSchema.parse(response.data);
}

export function useCreateProjectTradeMutation(
  options?: Omit<UseMutationOptions<ProjectTradeItem, Error, CreateProjectTradeRequest>, "mutationFn">,
) {
  return useMutation({
    mutationFn: createProjectTrade,
    ...options,
  });
}
